import { useMutation } from '@tanstack/react-query'
import { putConfirmPayment } from 'services/PaymentsService'

export const usePutConfirmPaymentMutation = () => {
  return useMutation({ mutationFn: putConfirmPayment })
}
